import React from 'react';
import BodyClassName from 'react-body-classname';

export const FULLPAGE_CLASSNAME = 'body--fullpage sticky--fullpage';
export const NO_FOOTER_CLASSNAME = 'body--no-footer';

export default Component => props => (
  <BodyClassName className={FULLPAGE_CLASSNAME}>
    <Component {...props} />
  </BodyClassName>
);
